import { Stack } from '@mui/material';
import { PropsWithChildren } from 'react';

import { suggestionListClasses } from './SuggestionList.styled';

export const SuggestionList = ({ children }: PropsWithChildren) => {
  return (
    <Stack className={suggestionListClasses.root} direction="row" gap={2} paddingY={1} flexWrap={'wrap'}>
      {children}
    </Stack>
  );
};
